import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from '@mui/material';
import {useStore} from "./store";


const calendarCafe = {
    завтрак: [
        { time: '09:20', description: '1-е классы' },
        { time: '09:25', description: '2-9-е классы' },
    ],
    обед: [
        { time: '12:00', description: '1-е классы' },
        { time: '12:05', description: '2-е классы' },
        { time: '12:55', description: '3-4-е классы' },
        { time: '13:45', description: '5-9-е классы' },
    ],
    полдник: [
        { time: '15:00', description: '1-9-е классы' },
    ],
    ужин: [
        { time: '17:00', description: '1-9-е классы' },
    ],
};

const CafeCalendar = () => {
    const { settings } = useStore();
    return (
        <TableContainer component={Paper} sx={{ maxWidth: 860, margin: '20px auto', boxShadow: 3 }}>
            <Typography variant={'h6'} align={'center'}>График посещения столовой в {settings.studyyears} учебном году</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Приём пищи</TableCell>
                        <TableCell>Время</TableCell>
                        <TableCell>Описание</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.entries(calendarCafe).map(([meal, entries]) =>
                        entries.map((entry, idx) => (
                            <TableRow key={`${meal}-${idx}`} hover>
                                {idx === 0 && (
                                    <TableCell rowSpan={entries.length} sx={{ fontWeight: 'bold', verticalAlign: 'middle' }}>
                                        {meal.charAt(0).toUpperCase() + meal.slice(1)}
                                    </TableCell>
                                )}
                                <TableCell>{entry.time}</TableCell>
                                <TableCell>{entry.description}</TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default CafeCalendar;
